import { ProfilesTemplates } from "../../Templates/ProfilesTemplates";

export const Profiles = () => {
  return <ProfilesTemplates />;
};
